import React from 'react';

import SvgIcon from '../WDS/SvgIcon/SvgIcon';

const Checkmark = (props) => (
    <SvgIcon {...props}>
        <path clipRule="evenodd" d="M23.5416 3.45844C24.1528 4.0697 24.1528 5.06074 23.5416 5.67199L9.19373 20.0198C8.9002 20.3134 8.50208 20.4783 8.08696 20.4783C7.67183 20.4783 7.27372 20.3134 6.98018 20.0198L0.458441 13.4981C-0.152814 12.8868 -0.152814 11.8958 0.458442 11.2845C1.0697 10.6733 2.06074 10.6733 2.67199 11.2845L8.08696 16.6995L21.328 3.45844C21.9393 2.84719 22.9303 2.84719 23.5416 3.45844Z" fillRule="evenodd" xmlns="http://www.w3.org/2000/svg"/>
    </SvgIcon>

);

export default Checkmark;
